import React, { useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Table, Tab, Tabs, Modal, Alert } from 'react-bootstrap';
import { credentials, params, urladmin } from '../actions/webServices';
import { FileUploader } from 'react-drag-drop-files';
import * as actionCreators from '../actions';
import SpinnerLoading from '../Components/SpinnerLoading';
import Inputs from '../Components/Inputs';
import axios from 'axios';
import moment from 'moment';

const initialState = {
    codemp: "",
    codsec: "",
    codcia: "",
    plapro: "",
    fecpro: null,
}

function Statics({ user, sections, empresas, companies }) {
    const [filters, setFilters] = useState(initialState);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([])
    const [showModalDetails, setShowModalDetails] = useState({ show: false, data: null, title: "" });
    const [showModalUpdate, setShowModalUpdate] = useState({ show: false, title: "" });
    const [updatedData, setUpdatedData] = useState({});
    const [file, setFile] = useState(null)

    const handleSearch = () => {
        setLoading(true);
        credentials(user)
        params.set('opcpm', 'AdminPrices');
        params.set('codemp', filters.codemp);
        params.set('codsec', filters.codsec);
        params.set('codcia', filters.codcia);
        params.set('codpro', filters.plapro);
        params.set('fecpro', filters.fecpro ? filters.fecpro.toLocaleDateString() : "");
        axios.post(urladmin, params)
            .then(res => {
                // console.log(res.data);
                setLoading(false);

                const reestructureData = [];

                res.data.productos.forEach((item) => {
                    const key = `${item.codemp}-${item.codsec}`;

                    if (!reestructureData.find(rdata => rdata.codemp === item.codemp)) {
                        reestructureData.push({
                            codemp: item.codemp,
                            empresa: res.data.empresas.find(empresa => empresa.codemp === item.codemp)?.nomemp,
                            seccion: [],
                        })
                    }

                    const empreData = reestructureData.find(rdata => rdata.codemp === item.codemp)

                    if (!empreData?.seccion.find(sec => sec.key === key)) {
                        const sec = res.data.secciones.find(seccion => seccion.codsec === item.codsec);
                        empreData.seccion.push({
                            key,
                            codigo: sec?.codsec,
                            nombre: sec?.nomsec,
                            productos: [],
                        });
                    }

                    try {
                        const detalles = JSON.parse(item.productos)
                        empreData.seccion.find(item => item.key === key).productos.push({
                            plan: item.nompro,
                            codpro: item.codpro,
                            detalles,
                        });
                    } catch {
                        empreData.seccion.find(item => item.key === key).productos.push({
                            plan: item.nompro,
                            codpro: item.codpro,
                            detalles: item.productos,
                        });
                    }
                });

                setData(reestructureData || [])
            })
    }

    const uploadFiles = async () => {
        if (file !== null) {
            const url = `${process.env.REACT_APP_NODE_APP}/uploadTerminos`;
            const options = { headers: { "Content-Type": "multipart/form-data" } };
            const formData = new FormData();
            const fileName = `constancia-${updatedData.codemp}-${updatedData.codsec}-${updatedData.codpro.split("-")[2]}-${moment(updatedData.fecpro).format("DD-MM-YYYY")}.pdf`
            formData.append("terminos", file, fileName);

            await axios.post(url, formData, options)
                .finally(() => {
                    setFile(null);
                })
        }
        else return;
    };

    const handleSubmit = () => {
        setLoading(true);
        credentials(user)
        params.set('opcpm', 'UpdatePrices');
        params.set('codemp', updatedData.codemp);
        params.set('codsec', updatedData.codsec);
        params.set('codcia', updatedData.codcia);
        params.set('codpro', updatedData.codpro);
        params.set('plapro', updatedData.plapro);
        params.set('fecpro', moment(updatedData.fecpro).format("DD-MM-YYYY"));
        params.set('despro', updatedData.despro);
        params.set('prepro', updatedData.prepro);
        params.set('pripro', updatedData.pripro);
        params.set('recid', updatedData.rec);
        axios.post(urladmin, params)
            .then(res => {
                uploadFiles().then(() => {
                    handleSearch();
                    setFilters({ ...filters, codemp: updatedData.codemp, codsec: updatedData.codsec, fecpro: null })
                    setShowModalUpdate(false);
                })
            })
    }

    return (
        <>
            <div className="abm">
                <div className='qs qs-inputs container max-shadow'>
                    <h1>Administrador de precios</h1>
                    <div className="row row-cols-sm-1 row-cols-md-3 row-cols-lg-4">
                        <Inputs
                            title={'Empresa'}
                            type={'select'}
                            options={empresas}
                            disabled={loading}
                            value={filters.codemp}
                            change={(e) => setFilters({ ...filters, codemp: e.value })}
                        />
                        <Inputs
                            title={'Seccion'}
                            type={'select'}
                            options={sections}
                            disabled={loading}
                            value={filters.codsec}
                            change={(e) => setFilters({ ...filters, codsec: e.value })}
                        />
                        <Inputs
                            title={'Compañia'}
                            type={'select'}
                            options={companies}
                            disabled={loading}
                            value={filters.codcia}
                            change={(e) => setFilters({ ...filters, codcia: e.value })}
                        />
                        <Inputs
                            title={'Plan'}
                            type={'select'}
                            options={[{ value: 1, label: "Primer Plan" }, { value: 2, label: "Segundo Plan" }, { value: 3, label: "Tercer Plan" }, { value: 4, label: "Cuarto Plan" }]}
                            disabled={loading}
                            value={filters.plapro}
                            change={(e) => setFilters({ ...filters, plapro: e.value })}
                        />
                        <Inputs
                            title={'Fecha modificacion (desde)'}
                            type={'datepicker'}
                            disabled={loading}
                            value={filters.fecpro}
                            change={(e) => setFilters({ ...filters, fecpro: e })}
                        />
                        <div className="d-flex justify-content-around mt-2">
                            <Inputs
                                type={"button"}
                                title={"Buscar"}
                                disabled={loading}
                                onClick={handleSearch}
                            />
                        </div>
                        <div className="d-flex justify-content-around mt-2">
                            <Inputs
                                type={"button"}
                                title={"Limpiar"}
                                disabled={loading}
                                onClick={() => setFilters(initialState)}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="abm">
                <div className='qs qs-inputs container max-shadow'>
                    {loading && <SpinnerLoading />}
                    <Tabs
                        defaultActiveKey={0}
                        className='mb-3'
                        fill
                    >
                        {data?.map((d, ix) =>
                            <Tab eventKey={ix} title={d?.empresa}>
                                {d.seccion.map(sec =>
                                    <>
                                        <h1>{sec.nombre}</h1>
                                        <Table striped responsive className='text-center'>
                                            <thead>
                                                <tr>
                                                    <th>Plan</th>
                                                    <th>Fecha</th>
                                                    <th>Precio</th>
                                                    <th>Dato extra</th>
                                                    <th>Detalles</th>
                                                    <th>Archivo</th>
                                                    <th>Opcion</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    sec.productos?.map(producto => producto.detalles?.map((prod, ix) => (
                                                        <React.Fragment key={ix}>
                                                            <tr>
                                                                <td>{producto?.plan}</td>
                                                                <td>{prod?.fecpro}</td>
                                                                <td>{prod?.prepro}</td>
                                                                <td>{prod?.pripro}</td>
                                                                <td
                                                                    onClick={() => setShowModalDetails({
                                                                        show: true,
                                                                        data: prod.despro,
                                                                        title: producto.plan
                                                                    })}
                                                                    className='pointer'
                                                                >Ver detalles</td>
                                                                <td>
                                                                    <a target="_blank" rel="noreferrer" href={`https://www.platform.com.ar/terminos/constancia-${d.codemp}-${sec.codigo}-${producto.codpro.split("-")[2]}-${prod.fecpro}.pdf`}>
                                                                        Link
                                                                    </a>
                                                                </td>
                                                                <td
                                                                    onClick={() => {
                                                                        setShowModalUpdate({
                                                                            show: true,
                                                                            title: `Actualización ${d?.empresa} / ${sec.nombre} / ${producto.plan}`
                                                                        })
                                                                        setUpdatedData({
                                                                            ...prod,
                                                                            fecpro: moment(prod.fecpro, "DD-MM-YYYY").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ"),
                                                                            codemp: d.codemp,
                                                                            codsec: sec.codigo,
                                                                            codpro: producto.codpro,
                                                                            plapro: producto.plan,
                                                                        })
                                                                    }}
                                                                    className='pointer'
                                                                >Actualizar</td>
                                                            </tr>
                                                        </React.Fragment>
                                                    )))
                                                }
                                            </tbody>
                                        </Table>
                                    </>
                                )}
                            </Tab>
                        )}
                    </Tabs>
                </div>
            </div>
            <Modal show={showModalDetails.show} onHide={() => setShowModalDetails({ show: false, data: null, title: "" })}>
                <Modal.Header closeButton>
                    <Modal.Title>{showModalDetails.title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='itemDescription'>
                        <p dangerouslySetInnerHTML={{ __html: showModalDetails.data }}></p>
                    </div>
                </Modal.Body>
            </Modal>
            <Modal show={showModalUpdate.show} onHide={() => setShowModalUpdate({ show: false, data: null, title: "" })} size='lg'>
                <Modal.Header closeButton>
                    <Modal.Title>{showModalUpdate.title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="qs qs-inputs">
                        <div className="row row-cols-sm-1 row-cols-md-2 row-cols-lg-3">
                            <Inputs
                                title={'Empresa'}
                                type={'select'}
                                options={empresas}
                                disabled={loading}
                                value={updatedData.codemp}
                                change={(e) => setUpdatedData({ ...updatedData, codemp: e.value })}
                            />
                            <Inputs
                                title={'Seccion'}
                                type={'select'}
                                options={sections}
                                disabled={loading}
                                value={updatedData.codsec}
                                change={(e) => setUpdatedData({ ...updatedData, codsec: e.value })}
                            />
                            <Inputs
                                title={'Compañia'}
                                type={'select'}
                                options={companies}
                                disabled={loading}
                                value={updatedData.codcia}
                                change={(e) => setUpdatedData({ ...updatedData, codcia: e.value })}
                            />
                            <Inputs
                                title={'Plan'}
                                type={'input'}
                                disabled={loading}
                                value={updatedData.plapro}
                                change={(e) => setUpdatedData({ ...updatedData, plapro: e.target.value })}
                            />
                            <Inputs
                                title={'Fecha modificacion (desde)'}
                                type={'datepicker'}
                                disabled={loading}
                                value={new Date(updatedData.fecpro)}
                                change={(e) => setUpdatedData({ ...updatedData, fecpro: e })}
                            />
                            <Inputs
                                title={'Código Producto'}
                                type={'text'}
                                disabled={loading}
                                value={updatedData.codpro}
                                change={(e) => setUpdatedData({ ...updatedData, codpro: e.target.value })}
                            />
                        </div>
                        <hr />
                        <Inputs
                            title={'Detalle del producto'}
                            type={'textarea'}
                            rows={10}
                            disabled={loading}
                            value={updatedData.despro}
                            change={(e) => setUpdatedData({ ...updatedData, despro: e.target.value })}
                        />
                        <div className="row row-cols-sm-1 row-cols-md-2 row-cols-lg-3">
                            <Inputs
                                title={'Precio'}
                                type={'number'}
                                disabled={loading}
                                value={updatedData.prepro}
                                change={(e) => setUpdatedData({ ...updatedData, prepro: e.target.value })}
                            />
                            <Inputs
                                title={'Suma / Dato extra'}
                                type={'number'}
                                disabled={loading}
                                value={updatedData.pripro}
                                change={(e) => setUpdatedData({ ...updatedData, pripro: e.target.value })}
                            />
                        </div>
                    </div>
                    <FileUploader
                        multiple={false}
                        handleChange={(file) => setFile(file)}
                        types={["pdf"]}
                        name="terminos"
                    />
                </Modal.Body>
                <Modal.Footer>
                    <Alert variant='info' className='mt-3'>
                        En caso de cambiar <i>Detalle del producto</i>, <i>Precio</i> o <i>Suma</i> se actualizará, si se toca otro dato se generará un nuevo registro
                    </Alert>
                    <div className="d-flex justify-content-around">
                        <Inputs
                            type={"button"}
                            title={"Guardar"}
                            disabled={loading}
                            onClick={handleSubmit}
                        />
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    )
}

function mapStateToProps(state) {
    return {
        user: state.mainReducer.user,
        companies: state.mainReducer.companies,
        sections: state.mainReducer.sections,
        empresas: state.mainReducer.empresas,

        statics: state.adminReducer.statics,
    }
};

const mapDispatchToProps = function (dispatch) {
    return bindActionCreators(actionCreators, dispatch)
};

export default connect(mapStateToProps, mapDispatchToProps)(Statics);
